import type { FaireBrandEntity } from "../../entity_types/brand";

// EU Brand — real Faire brand (b_5qsm2e4kdh), shown under an anonymized name.
// Identity metadata from ANALYTICS.CANONICAL.BRANDS; backs the ads-manager-2
// overview "EU" brand-type variant (advertiser 8420071495843407397).
export const b_5qsm2e4kdh: FaireBrandEntity = {
  token: "b_5qsm2e4kdh",
  type: "brand",
  name: "EU Brand",
  description: "Paper goods and greeting cards, designed and printed in Europe.",
  location: "Germany",
  isTopShop: true,
  tags: ["paper-novelty", "stationery"],
  meta: {
    source: "snowflake",
    importedAt: "2026-10-12T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
